import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app";
import "./app.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { AppProvider } from "providers/appProvider";
import { ClerkProvider } from "@clerk/clerk-react";

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || "";

let params = new URL(document.location.href).searchParams;

let isHarbour = localStorage.getItem("isHarbourClub") === "true";
if (params.get("via") === "harbour") {
  isHarbour = true;
  localStorage.setItem("isHarbourClub", "true");
}

let isBiz4Biz = localStorage.getItem("isBiz4Biz") === "true";
if (params.get("via") === "biz4biz") {
  isBiz4Biz = true;
  localStorage.setItem("isBiz4Biz", "true");
}

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <ClerkProvider
        publishableKey={clerkPubKey}
        allowedRedirectOrigins={[
          process.env.REACT_APP_BUYER_APP_URL as string,
          process.env.REACT_APP_SELLER_APP_URL as string,
          process.env.REACT_APP_VDR_APP_URL as string,
        ]}
        signInUrl="/sign-in"
        signUpUrl="/sign-up"
      >
        <AppProvider isHarbour={isHarbour} isBiz4Biz={isBiz4Biz}>
          <App />
        </AppProvider>
      </ClerkProvider>
    </React.StrictMode>
  );
}

reportWebVitals();
